import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ALERT_LOADING_EVENT } from 'src/app/services/alert.service';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  loading$ = this.svLoading.loading$
  constructor(
    private svLoading: LoadingService) {

  }
}
